import { FC } from 'react'

import { Translation } from 'cng-common/features/translations'
import { ConfirmationDialog } from 'partner360/components/confirmationDialog/ConfirmationDialog'

import { BUSINESS_PRIORITIES_TRANSLATION_KEYS } from '../../../configs/translations'

const KEYS = BUSINESS_PRIORITIES_TRANSLATION_KEYS

interface IDeleteConfirmationDialogProps {
  isVisible: boolean
  onConfirm: () => void
  onReject: () => void
}

export const DeleteConfirmationDialog: FC<IDeleteConfirmationDialogProps> = ({
  isVisible,
  onConfirm,
  onReject,
}) => (
  <ConfirmationDialog
    isVisible={isVisible}
    title={KEYS.deleteConfirmDialog.title}
    confirmBtnText={KEYS.deleteConfirmDialog.confirm}
    rejectBtnText={KEYS.deleteConfirmDialog.cancel}
    isApplyNegative
    onConfirm={onConfirm}
    onReject={onReject}
    content={<Translation text={KEYS.deleteConfirmDialog.message} />}
  />
)

DeleteConfirmationDialog.displayName = 'DeleteConfirmationDialog'
